import { createActions } from "reduxsauce";

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  businessRequest: ["businessId"],
  businessesCountRequest: [],
  businessAllRequest: ["options"],
  businessUpdateRequest: ["business"],
  businessDeleteRequest: ["businessId"],
  cacheBusinessesRequest: [],
  enterpriseCustomersRequest: ["businessId", "options"],
  enterpriseCustomersCountRequest: ["businessId"],
  businessCustomersSearchSummaryRequest: ["businessId", "params"],
  approvedBusinessesDetailRequest: ["businessId"],
  enableCardPaymentsRequest: ["businessId"],
  overrideCardFeesRequest: ["businessId", "fees"],
  overrideMomoFeesRequest: ["businessId", "fees"],
  passingFeesOnRequest: ["businessId"],
  verificationStartedRequest: ["businessId"],
  businessVerificationRequest: ["businessId"],
  invitationUptakeRequest: ["businessId", "planId", "query", "options"],
  segmentRequest: ["businessId"],
  associateSegmentWithBusinessCustomerRequest: ["segmentId", "bcId", "businessId", "refreshParams"],
  tagRequest: ["businessId"],
  associateTagWithBusinessCustomerRequest: ["tagId", "bcId", "businessId", "refreshParams"],
  dissociateTagFromBusinessCustomerRequest: ["tagId", "bcId", "businessId", "refreshParams"],
  linkPlanWithBusinessCustomerRequest: ["planId", "bcId", "businessId", "refreshParams"],
  reportConfigurationsRequest: ["businessId"],
  createReportConfigurationRequest: ["businessId", "reportConfiguration"],
  generateReportConfigurationRequest: ["configId", "configName"],
  generateReportConfigurationClearError: [],
  deleteReportConfigurationRequest: ["configId", "businessId"],
  deleteReportConfigurationClearError: [],
  enableCustomPSPRequest: ["businessId"],
  toggleReqsEnabledRequest: ["businessId"],
  createSignupReqsRequest: ["businessId", "tagGroupIds"],
  fetchSignupReqsRequest: ["businessId"],
  deleteSignupReqRequest: ["businessId", "signupReqId"],
  fetchSignupReqExclusionsRequest: ["businessId"],
  createSignupReqExclusionsRequest: ["businessId", "planGroupIds"],
  deleteSignupReqExclusionRequest: ["businessId", "exclusionId"],
  businessesByNameRequest: ["nameQuery", "options"],
  businessesByNameCountRequest: ["nameQuery"],
  createSegmentRequest: ["segment"],
  createTagRequest: ["tag"],
  createTagGroupRequest: ["tagGroup"],
  updateTagRequest: ["tagId", "tag"],
  updateTagGroupRequest: ["groupId", "tagGroup"],
  tagGroupRequest: ["businessId"],
  tagGroupGraphedRequest: ["businessId"],
  tagsRequest: ["businessId"],

  businessSuccess: ["business"],
  businessesCountSuccess: ["businessesCount"],
  businessAllSuccess: ["businesses"],
  businessUpdateSuccess: ["business"],
  businessDeleteSuccess: [],
  cacheBusinessesSuccess: ["cacheBusinesses"],
  enterpriseCustomersSuccess: ["enterpriseCustomers"],
  enterpriseCustomersCountSuccess: ["enterpriseCustomersCount"],
  businessCustomersSearchSummarySuccess: ["businessCustomersSearchSummary"],
  approvedBusinessesDetailSuccess: ["approvedVerificationDetails"],
  enableCardPaymentsSuccess: ["business"],
  overrideCardFeesSuccess: ["business"],
  overrideMomoFeesSuccess: ["business"],
  passingFeesOnSuccess: ["business"],
  verificationStartedSuccess: ["verificationStarted"],
  businessVerificationSuccess: ["businessVerification"],
  invitationUptakeSuccess: ["invitationUptake"],
  segmentSuccess: ["segment"],
  associateSegmentWithBusinessCustomerSuccess: ["result"],
  tagSuccess: ["tag"],
  associateTagWithBusinessCustomerSuccess: ["result"],
  dissociateTagFromBusinessCustomerSuccess: ["result"],
  linkPlanWithBusinessCustomerSuccess: ["result"],
  reportConfigurationsSuccess: ["reportConfigurations"],
  createReportConfigurationSuccess: ["reportConfiguration"],
  generateReportConfigurationSuccess: [],
  deleteReportConfigurationSuccess: [],
  enableCustomPSPSuccess: ["business"],
  toggleReqsEnabledSuccess: ["business"],
  createSignupReqsSuccess: ["signupReqs"],
  fetchSignupReqsSuccess: ["signupReqs"],
  deleteSignupReqSuccess: ["signupReqs"],
  fetchSignupReqExclusionsSuccess: ["signupReqExclusions"],
  createSignupReqExclusionsSuccess: ["signupReqExclusions"],
  deleteSignupReqExclusionSuccess: ["signupReqExclusions"],
  businessesByNameSuccess: ["businessesByName"],
  businessesByNameCountSuccess: ["businessesByNameCount"],
  createSegmentSuccess: ["segmentData"],
  createTagSuccess: ["tagData"],
  createTagGroupSuccess: ["tagGroupData"],
  updateTagSuccess: ["tag"],
  updateTagGroupSuccess: ["tagGroup"],
  tagGroupSuccess: ['tagGroups'],
  tagGroupGraphedSuccess: ["tagGroupsGraphed"],
  tagsSuccess: ["tags"],

  businessFailure: ["error"],
  businessesCountFailure: ["error"],
  businessAllFailure: ["error"],
  businessUpdateFailure: ["error"],
  businessDeleteFailure: ["error"],
  cacheBusinessesFailure: ["error"],
  enterpriseCustomersFailure: ["error"],
  enterpriseCustomersCountFailure: ['error'],
  businessCustomersSearchSummaryFailure: ["error"],
  approvedBusinessesDetailFailure: ['error'],
  enableCardPaymentsFailure: ["error"],
  overrideMomoFeesFailure: ["error"],
  overrideCardFeesFailure: ["error"],
  passingFeesOnFailure: ["error"],
  verificationStartedFailure: ['error'],
  businessVerificationFailure: ['error'],
  invitationUptakeFailure: ["error"],
  segmentFailure: ["error"],
  associateSegmentWithBusinessCustomerFailure: ["error"],
  tagFailure: ["error"],
  associateTagWithBusinessCustomerFailure: ["error"],
  dissociateTagFromBusinessCustomerFailure: ["error"],
  linkPlanWithBusinessCustomerFailure: ["error"],
  reportConfigurationsFailure: ["error"],
  createReportConfigurationFailure: ["error"],
  generateReportConfigurationFailure: ["error"],
  deleteReportConfigurationFailure: ["error"],
  enableCustomPSPFailure: ["error"],
  toggleReqsEnabledFailure: ["error"],
  createSignupReqsFailure: ["error"],
  fetchSignupReqsFailure: ["error"],
  deleteSignupReqFailure: ["error"],
  fetchSignupReqExclusionsFailure: ["error"],
  createSignupReqExclusionsFailure: ["error"],
  deleteSignupReqExclusionFailure: ["error"],
  businessesByNameFailure: ["error"],
  businessesByNameCountFailure: ["error"],
  createSegmentFailure: ["error"],
  createTagFailure: ["error"],
  createTagGroupFailure: ["error"],
  updateTagGroupFailure: ["error"],
  updateTagFailure: ["error"],
  tagGroupFailure: ["error"],
  tagGroupGraphedFailure: ["error"],
  tagsFailure: ["error"],
});

export const BusinessTypes = Types;
export default Creators;
